module.exports = __webpack_public_path__ + "img/masscoms_3.0584fec5.png";